import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { payload, id }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const schedule = await fetch(`${URI_TARIFF_PLAN}tariff-schedule/${id}`, opts);
  const jsonResult = await schedule.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
